import Headroom from "headroom.js"

const mainHeader = document.querySelector(".main-header")

const headRoomHeaderOptions = {
  offset: (mainHeader?.clientHeight ?? 0) * 3,
}

export const headRoomHeader = mainHeader ? new Headroom(mainHeader, headRoomHeaderOptions) : null

if (mainHeader !== null) {
  headRoomHeader?.init()

  const resizeObserver = new ResizeObserver(() => {
    document.querySelector<HTMLElement>("body, html")?.style.setProperty("scroll-padding-top", `${mainHeader.clientHeight}px`)
  })

  resizeObserver.observe(mainHeader)
}
